@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

$var-dropdown-width: 360px;

.tool-option {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-s;

	&__type {
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyFontLight;
	}
}

.equipment-option {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: Constants.$val-spacing-s;
}

.item-table-footer {
	&__action, &__dropdown {
		display: flex;
		min-height: Constants.$val-spacing-xl;
		align-items: center;
		padding-left: Constants.$val-spacing-s;
		flex-direction: row;
	}

	&__action {
		color: Colors.$col-blue;
		cursor: pointer;
		width: fit-content;
	}

	&__dropdown {
		gap: Constants.$val-spacing-s;
	}
}

.item-dropdown {
	min-width: $var-dropdown-width;
	background-color: white;

	& :global(.dropdown-item__content) {
		justify-content: flex-start;
	}
}

.item-option {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: Constants.$val-spacing-s;
	align-items: flex-start;
	margin-left: Constants.$val-spacing-s;

	&__details {
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyFontLight;
	}
}

.section {
	background-color: Colors.$col-white;
	margin-bottom: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-m;
	border-bottom: 1px solid Colors.$col-greyConnection;
}

.section-title {
	color: Colors.$col-grey;
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeBig;
	display: flex;
	flex-direction: column;
	margin-bottom: Constants.$val-spacing-m;
}

.container {
	background-color: Colors.$col-greyLight;
	padding: Constants.$val-spacing-s;
}

.title {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeXBig;
	font-weight: bold;
}

.buttons-container {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	justify-content: end;
}

@mixin label {
	background-color: Colors.$col-greyBackground;
	font-weight: bold;
	margin-right: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
	white-space: nowrap;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: Constants.$val-spacing-xxs;
	padding-bottom: Constants.$val-spacing-xxs;
	min-width: 130px;
	margin-top: Constants.$val-spacing-xs;
}

@mixin transparent {
	background-color: transparent;
	border: 2px solid Colors.$col-greyConnection;
	margin-top: Constants.$val-spacing-xxs;
}

.label {
	&__new {
		@include label;
		color: Colors.$col-grey
	}

	&__open {
		@include label;
		color: black;
	}

	&__completed {
		@include label;
		color: Colors.$col-green;
	}

	&__pending {
		@include label;
		color: Colors.$col-orange;
	}

	&__new_t {
		@include label;
		@include transparent;
		color: Colors.$col-grey;
	}

	&__open_t {
		@include label;
		@include transparent;
		color: black;
	}

	&__completed_t {
		@include label;
		@include transparent;
		color: Colors.$col-green;
	}

	&__pending_t {
		@include label;
		@include transparent;
		color: Colors.$col-orange;
	}
}

.total-cost-container {
	background-color: Colors.$col-greyBackground;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: end;
	font-weight: bold;
	padding-right: Constants.$val-spacing-m;
	padding-top: Constants.$val-spacing-s;
	padding-bottom: Constants.$val-spacing-m;
	height: 50px;
}

.field-row {
	margin-bottom: Constants.$val-spacing-l;
	margin-top: Constants.$val-spacing-l;
}

.tool-type {
	color: Colors.$col-design-grey15;
}
